/* ==================================================================== *
 *  TEMPORARY placeholder experiential events.                           *
 *                                                                       *
 *  Shown on the home page and on the community pages they fit, until    *
 *  the backend serves the real events calendar. Each card offers an     *
 *  "Express your interest" email popup and a "View more" detail modal.  *
 *                                                                       *
 *  TO REMOVE once the backend is live: delete this file, the            *
 *  <PlaceholderEvents> usages (home EventsRail + community event         *
 *  sections), and the ev-*.jpg images in public/img/gen/.               *
 * ==================================================================== */

export type PlaceholderEvent = {
  key: string
  title: string
  when: string
  where: string
  pillar: string
  tagline: string
  /** Short line for the card. */
  blurb: string
  /** Full description for the "View more" detail modal. */
  long: string
  image: string
  /** Community page names (page.name) this event should also appear on. */
  communities: string[]
}

export const placeholderEvents: PlaceholderEvent[] = [
  {
    key: 'ananta',
    title: 'Ananta',
    when: 'End October / Beginning November',
    where: 'Delhi NCR',
    pillar: 'Transform + Celebrate',
    tagline: 'A festival of spirit, culture and conscious living',
    blurb: 'A festival of spirit, culture and conscious living: yoga, wisdom, music, food and arts.',
    long: 'The day begins with yoga, fitness and wellness, followed by wisdom keynotes, renowned astrologers and one-on-one sessions. Culinary experiences and cultural activities lead into an evening of music, creating a vibrant precursor to Diwali.',
    image: '/img/gen/ev-ananta.jpg',
    communities: ['Zen', 'Cosmos', 'Rhythm'],
  },
  {
    key: 'new-year',
    title: 'New Year Transformations',
    when: '4th Week of January',
    where: 'Kerala / Pondicherry',
    pillar: 'Transform',
    tagline: 'New year, new habits, new you',
    blurb: 'A five-day wellness reset: yoga, creative renewal and a complete digital detox.',
    long: 'A five-day wellness reset combining yoga, creative renewal and detox, with flexible experiences designed for holistic personal transformation.',
    image: '/img/gen/ev-new-year.jpg',
    communities: ['Zen'],
  },
  {
    key: 'chemistry',
    title: 'The Chemistry Weekend',
    when: "Valentine's Weekend (Mid-February)",
    where: 'Goa / Pondicherry',
    pillar: 'Connect',
    tagline: 'Same vibes, new people, real stories',
    blurb: 'A verified dating retreat for singles: matched experiences, hosted dinners, bonfire and music.',
    long: 'A curated dating retreat for singles featuring matched experiences, hosted dinners, bonfire, dance and music.',
    image: '/img/gen/ev-chemistry.jpg',
    communities: [],
  },
  {
    key: 'listening-room',
    title: 'The Listening Room',
    when: 'End February',
    where: 'Bangalore / NCR',
    pillar: 'Celebrate',
    tagline: 'Turn up the good vibes',
    blurb: 'An intimate music retreat: artist masterclasses, acoustic jams and curated listening.',
    long: 'An intimate music evening featuring artist acoustic jams and curated listening experiences in a relaxed setting.',
    image: '/img/gen/ev-listening-room.jpg',
    communities: ['Rhythm'],
  },
  {
    key: 'rewards',
    title: 'Rewards and Recognition',
    when: 'March',
    where: 'Delhi',
    pillar: 'Celebrate',
    tagline: 'Every effort deserves to be celebrated',
    blurb: 'A gala awards evening celebrating achievers across music, yoga, fitness, arts and more.',
    long: 'A gala awards evening honouring achievers of all ages who have excelled in music, yoga, fitness, photography, arts and crafts, culinary and more.',
    image: '/img/gen/ev-rewards.jpg',
    communities: [],
  },
]

/** Placeholder events that should appear on a given community page. */
export function placeholderEventsFor(community: string): PlaceholderEvent[] {
  const name = community.trim()
  return placeholderEvents.filter((e) => e.communities.includes(name))
}
